import { render, staticRenderFns } from "./CheckedSquareIcon.vue?vue&type=template&id=19062dc9&scoped=true"
import script from "./CheckedSquareIcon.vue?vue&type=script&lang=js"
export * from "./CheckedSquareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19062dc9",
  null
  
)

export default component.exports